'use client';

import { useDecisions } from './useDecisions';

export const useSlaGroupingDecisions = () => {
    const slaGrouping = useDecisions('ff_sla_grouping');

    return {
        isSlaGroupingEnabled: slaGrouping,
    };
};
